// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_3miel2pJ8dglG5FIMsUsxv","title-wrapper":"kSeRIClG2jK1rQzBmpOO2","placeholder":"_1JtkcgmYLm7wqjLUU8hsVP"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/RecoveryPlan/components/RecoverySection.mod.css
// module id = 2123
// module chunks = 0